import { useNavigate } from "react-router-dom";
import { CloudOff } from "lucide-react";

import { useI18n } from "@/i18n/I18nContext";
import { useOnline } from "../useCore";
import { StatusBanner, DetailRow, DetailList, V3Actions, V3_PRIMARY, V3_SECONDARY } from "./v3";

// M26: the shared core is unreachable or the device is offline; loading sent nothing, so no draft or change is claimed.
export function ConnectionError({ onRetry }) {
  const { t } = useI18n();
  const online = useOnline();
  const navigate = useNavigate();
  const back = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));
  return (
    <div data-testid="member-connection-error" data-m="M26" data-online={online ? "true" : "false"}>
      <StatusBanner tone="sand" icon={CloudOff} role="alert" title={online ? "Keine Verbindung zum System" : "Offline"}
        text={online ? t("common.connection_error") : "Dein Gerät ist gerade nicht mit dem Internet verbunden."} testid="member-connection-banner" />
      <DetailList>
        <DetailRow label="Status" value={online ? "Das VISIBILIS-System antwortet gerade nicht" : "Offline"} testid="member-connection-status" />
        <DetailRow label="Dein Entwurf" value="Beim Laden wurde nichts gesendet oder geändert" testid="member-connection-draft" />
        <DetailRow label="Aktualisierung" value={online ? "Möglich, sobald das System wieder antwortet" : "Erst nach erneuter Verbindung möglich"} testid="member-connection-update" />
        <DetailRow label="Nächster Schritt" value="Verbindung prüfen und gezielt erneut laden" testid="member-connection-next" />
      </DetailList>
      <V3Actions>
        <button type="button" onClick={onRetry} data-testid="member-connection-retry" className={V3_PRIMARY}>Erneut laden</button>
        <button type="button" onClick={back} data-testid="member-connection-back" className={V3_SECONDARY}>Zurück</button>
      </V3Actions>
    </div>
  );
}
